import React, { lazy } from 'react';

import { useMediaQuery } from '@chakra-ui/react';

import { MediaQueryAmountsEnum } from '@/enum/mediaQueryAmounts.enum';

const FreeTrialSectionDesktop = lazy(() => import('./desktop'));
const FreeTrialSectionMobile = lazy(() => import('./mobile'));

/**
 * Chooser-component for choosing mobile or desktop version of Free Trial Section in Home page
 * @component
 * @example
 * <FreeTrialSection />.
 */
const FreeTrialSection: React.FC = () => {
  const [notADesktop] = useMediaQuery(MediaQueryAmountsEnum.isNotADesktop);

  return notADesktop ? <FreeTrialSectionMobile /> : <FreeTrialSectionDesktop />;
};

export default FreeTrialSection;
